import { jwtDecode } from "jwt-decode";

export const ADMIN_USERNAMES = new Set(["moscarete79", "oscars"]);
export const ADMIN_EMAILS = new Set([
  "moscarete79@gmail.com",
  "oscars@radware.com",
]);

export function isManagementHostname(hostname) {
  const host = String(hostname || "")
    .split(":")[0]
    .trim();
  const match = host.match(/^172\.30\.4\.(\d+)$/);
  if (!match) return false;
  const octet = Number(match[1]);
  return octet >= 0 && octet <= 255;
}

export function isAdminJwtSub(token) {
  if (!token) return false;
  try {
    const { sub } = jwtDecode(token);
    return typeof sub === "string" && ADMIN_USERNAMES.has(sub);
  } catch {
    return false;
  }
}

export function canShowAdminAccess({
  token = typeof localStorage !== "undefined" ? localStorage.getItem("jwt_token") : null,
  hostname = typeof window !== "undefined" ? window.location.hostname : "",
} = {}) {
  return isManagementHostname(hostname) && isAdminJwtSub(token);
}
